import { render, staticRenderFns } from "./KioskStatusPanel.vue?vue&type=template&id=0b5d6678&scoped=true"
import script from "./KioskStatusPanel.vue?vue&type=script&lang=js"
export * from "./KioskStatusPanel.vue?vue&type=script&lang=js"
import style0 from "./KioskStatusPanel.vue?vue&type=style&index=0&id=0b5d6678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d6678",
  null
  
)

export default component.exports